var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Collapse } from '../../../ts/components/Collapse';
class MapSectionController {
    constructor(section) {
        this.originalViewBox = null;
        this.currentViewBox = null;
        this.isZoomed = false;
        this.isDragging = false;
        this.dragStartClientX = 0;
        this.dragStartClientY = 0;
        this.dragStartViewBoxX = 0;
        this.dragStartViewBoxY = 0;
        this.pinchInitialDistance = 0;
        this.isPinching = false;
        this.section = section;
        this.viewport = this.section.find('.section-map-viewport');
        this.svg = this.section.find('svg').get(0);
        this.zoomToggle = this.section.find('.section-map-btn-zoom-toggle');
        this.captureOriginalViewBox();
        this.bindZoom();
        this.bindPanning();
        this.bindPinchZoom();
        this.bindHoverSync();
        this.updateZoomToggle();
    }
    captureOriginalViewBox() {
        const viewBoxAttr = this.svg.getAttribute('viewBox');
        if (viewBoxAttr) {
            const [x, y, width, height] = viewBoxAttr.split(/\s+/).map(Number);
            this.originalViewBox = { x, y, width, height };
            this.currentViewBox = Object.assign({}, this.originalViewBox);
            return;
        }
        const width = Number(this.svg.getAttribute('width')) || this.svg.clientWidth;
        const height = Number(this.svg.getAttribute('height')) || this.svg.clientHeight;
        this.originalViewBox = { x: 0, y: 0, width, height };
        this.currentViewBox = Object.assign({}, this.originalViewBox);
        this.applyViewBox();
    }
    bindZoom() {
        var _a;
        (_a = this.zoomToggle) === null || _a === void 0 ? void 0 : _a.on('click', () => {
            if (this.isZoomed) {
                this.resetZoom();
            }
            else {
                this.zoomToCenter();
            }
        });
    }
    zoomToCenter() {
        if (!this.originalViewBox) {
            return;
        }
        const nextViewBox = {
            width: this.originalViewBox.width / 2,
            height: this.originalViewBox.height / 2,
            x: this.originalViewBox.x + this.originalViewBox.width / 4,
            y: this.originalViewBox.y + this.originalViewBox.height / 4,
        };
        this.currentViewBox = nextViewBox;
        this.isZoomed = true;
        this.viewport.addClass('is-zoomed');
        this.applyViewBox();
        this.updateZoomToggle();
    }
    resetZoom() {
        if (!this.originalViewBox) {
            return;
        }
        this.currentViewBox = Object.assign({}, this.originalViewBox);
        this.isZoomed = false;
        this.isDragging = false;
        this.viewport.removeClass('is-zoomed is-dragging');
        this.applyViewBox();
        this.updateZoomToggle();
    }
    updateZoomToggle() {
        if (!this.zoomToggle) {
            return;
        }
        this.zoomToggle.text(this.isZoomed ? '-' : '+');
        this.zoomToggle.attr('aria-pressed', this.isZoomed ? 'true' : 'false');
    }
    bindPanning() {
        this.svg.addEventListener('pointerdown', (event) => {
            if (!this.isZoomed || event.button !== 0 || !this.currentViewBox)
                return;
            this.isDragging = true;
            this.dragStartClientX = event.clientX;
            this.dragStartClientY = event.clientY;
            this.dragStartViewBoxX = this.currentViewBox.x;
            this.dragStartViewBoxY = this.currentViewBox.y;
            this.viewport.addClass('is-dragging');
            //this.svg.setPointerCapture(event.pointerId);
        });
        this.svg.addEventListener('pointermove', (event) => {
            if (!this.isDragging || !this.viewport || !this.currentViewBox || !this.originalViewBox)
                return;
            const viewportRect = this.viewport.get(0).getBoundingClientRect();
            if (viewportRect.width <= 0 || viewportRect.height <= 0)
                return;
            const unitsPerPixelX = this.currentViewBox.width / viewportRect.width;
            const unitsPerPixelY = this.currentViewBox.height / viewportRect.height;
            const deltaX = (event.clientX - this.dragStartClientX) * unitsPerPixelX;
            const deltaY = (event.clientY - this.dragStartClientY) * unitsPerPixelY;
            this.currentViewBox.x = this.clamp(this.dragStartViewBoxX - deltaX, this.originalViewBox.x, this.originalViewBox.x + this.originalViewBox.width - this.currentViewBox.width);
            this.currentViewBox.y = this.clamp(this.dragStartViewBoxY - deltaY, this.originalViewBox.y, this.originalViewBox.y + this.originalViewBox.height - this.currentViewBox.height);
            this.applyViewBox();
        });
        const stopDragging = (event) => {
            if (!this.isDragging)
                return;
            this.isDragging = false;
            this.viewport.removeClass('is-dragging');
            //if (this.svg.hasPointerCapture(event.pointerId)) this.svg.releasePointerCapture(event.pointerId);
        };
        this.svg.addEventListener('pointerup', stopDragging);
        this.svg.addEventListener('pointercancel', stopDragging);
    }
    bindPinchZoom() {
        this.svg.addEventListener('touchstart', (event) => {
            if (event.touches.length === 2) {
                event.preventDefault();
                this.isPinching = true;
                this.pinchInitialDistance = this.getDistance(event.touches[0].clientX, event.touches[0].clientY, event.touches[1].clientX, event.touches[1].clientY);
            }
        });
        this.svg.addEventListener('touchmove', (event) => {
            if (!this.isPinching || event.touches.length !== 2)
                return;
            event.preventDefault();
            const currentDistance = this.getDistance(event.touches[0].clientX, event.touches[0].clientY, event.touches[1].clientX, event.touches[1].clientY);
            const scale = currentDistance / this.pinchInitialDistance;
            // Zoom out threshold: < 0.85
            if (scale < 0.85 && this.isZoomed) {
                this.resetZoom();
            }
            // Zoom in threshold: > 1.15
            else if (scale > 1.15 && !this.isZoomed) {
                this.zoomToCenter();
            }
        });
        const resetPinch = () => {
            this.isPinching = false;
            this.pinchInitialDistance = 0;
        };
        this.svg.addEventListener('touchend', resetPinch);
        this.svg.addEventListener('touchcancel', resetPinch);
    }
    getDistance(x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        return Math.sqrt(dx * dx + dy * dy);
    }
    bindHoverSync() {
        this.section.find('.section-map-link').on('mouseenter', (event, link) => {
            this.highlight(link.data('number'));
        }).on('mouseleave', (event, link) => {
            this.clearHighlight(link.data('number'));
        }).on('click', (event, link) => {
            sessionStorage.setItem('fromMap', 'true');
        });
        this.section.find('svg #exhibitions > g').on('mouseenter', (event, group) => {
            this.highlight(group.attr('id').split('-')[1]);
        }).on('mouseleave', (event, group) => {
            this.clearHighlight(group.attr('id').split('-')[1]);
        }).on('click', (event, group) => {
            sessionStorage.setItem('fromMap', 'true');
            location.href = this.section.find(`.section-map-link[data-number="${group.attr('id').split('-')[1]}"]`).attr('href');
        });
    }
    highlight(number) {
        this.section.find(`.section-map-link[data-number="${number}"]`).addClass('text-decoration-underline');
        this.section.find(`.exhibition-${number}`).addClass('is-highlighted');
    }
    clearHighlight(number) {
        this.section.find(`.section-map-link[data-number="${number}"]`).removeClass('text-decoration-underline');
        this.section.find(`.exhibition-${number}`).removeClass('is-highlighted');
    }
    applyViewBox() {
        if (!this.svg || !this.currentViewBox) {
            return;
        }
        const { x, y, width, height } = this.currentViewBox;
        this.svg.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
    }
    clamp(value, min, max) {
        if (value < min) {
            return min;
        }
        if (value > max) {
            return max;
        }
        return value;
    }
}
export class Map extends Component {
    constructor() {
        super('Map', false);
        this.cameFromMap = false;
        this.cameFromMap = sessionStorage.getItem('fromMap') === 'true';
        sessionStorage.removeItem('fromMap');
        if (sessionStorage.getItem('reopenMap') === 'true') {
            sessionStorage.removeItem('reopenMap');
            setTimeout(() => {
                Collapse.show('carte');
            }, 100);
        }
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.section-map').each((mapSection) => {
                new MapSectionController(mapSection);
            });
            $('#btn-back').on('click', (event) => {
                if (this.cameFromMap) {
                    event.preventDefault();
                    sessionStorage.setItem('reopenMap', 'true');
                    history.back();
                }
            });
            this.success();
        });
    }
}
